import type { ChapterEventStatus } from "../api/chapterEventsApi";

/**
 * The one place a chapter event request's status is turned into words.
 *
 * Shared by the chairman's screens and the secretariat's, because the two must
 * never describe the same row differently — "Submitted for CPD allocation" means
 * "waiting on you" to one of them and "sent" to the other, and a second copy of
 * this map is how those drift apart.
 */
const TONES: Record<ChapterEventStatus, { label: string; tone: string }> = {
  pending:              { label: "Awaiting approval",  tone: "bg-amber-50 text-amber-700 border-amber-200" },
  approved:             { label: "Approved",           tone: "bg-blue-50 text-blue-700 border-blue-200" },
  rejected:             { label: "Rejected",           tone: "bg-red-50 text-red-600 border-red-200" },
  attendance_submitted: { label: "Awaiting allocation", tone: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  allocated:            { label: "CPD allocated",      tone: "bg-green-50 text-green-700 border-green-200" },
};

export default function ChapterEventStatusBadge({
  status,
  className = "",
}: {
  status: ChapterEventStatus | string;
  className?: string;
}) {
  const entry = TONES[status as ChapterEventStatus] ?? {
    label: String(status ?? "—"),
    tone: "bg-gray-100 text-gray-600 border-gray-200",
  };

  return (
    <span
      className={`inline-flex whitespace-nowrap text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full border ${entry.tone} ${className}`}
    >
      {entry.label}
    </span>
  );
}

export { TONES as CHAPTER_EVENT_STATUS_TONES };
